import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";

function getYouTubeId(url) {
  try {
    const u = new URL(url);
    if (u.searchParams.has("v")) {
      return u.searchParams.get("v");
    }
    const paths = u.pathname.split("/");
    return paths[paths.length - 1];
  } catch (e) {
    console.warn("Invalid YouTube URL:", url);
    return null;
  }
}

const THUMBNAIL_QUALITIES = [
  // 'maxresdefault.jpg',
  // 'sddefault.jpg',
  "hqdefault.jpg",
  "mqdefault.jpg",
  "default.jpg",
];

const YouTubeThumbnail = ({ videoUrl, altText }) => {
  const videoId = getYouTubeId(videoUrl);
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!videoId) return;
    let cancelled = false;
    let idx = 0;

    const tryLoad = () => {
      const filename = THUMBNAIL_QUALITIES[idx];
      const url = `https://img.youtube.com/vi/${videoId}/${filename}`;
      const img = new Image();
      img.onload = () => {
        if (!cancelled) setSrc(url);
      };
      img.onerror = () => {
        if (!cancelled && idx < THUMBNAIL_QUALITIES.length - 1) {
          idx += 1;
          tryLoad();
        }
      };
      img.src = url;
    };

    tryLoad();
    return () => {
      cancelled = true;
    };
  }, [videoId]);

  // If the videoId is invalid
  if (!videoId)
    return (
      <Box
        sx={{
          width: "100%",
          pt: "56.25%",
          bgcolor: "grey.200",
          borderRadius: 1,
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text.secondary",
          }}
        >
          Invalid YouTube URL
        </Box>
      </Box>
    );

  // If the thumbnail is still loading
  if (!src)
    return (
      <Box
        sx={{
          width: "100%",
          pt: "56.25%",
          bgcolor: "grey.200",
          borderRadius: 1,
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text.secondary",
          }}
        >
          Loading...
        </Box>
      </Box>
    );

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        pt: "56.25%", // 16:9
        overflow: "hidden",
        borderRadius: 1,
        // boxShadow: 5,
        // "&:hover": {
        //   cursor: "pointer",
        //   boxShadow: 7,
        // },
        boxShadow: `0px 1px 3px rgba(0, 0, 0, 0.2),
        0px 1px 1px rgba(0, 0, 0, 0.14),
        0px 2px 1px rgba(0, 0, 0, 0.12)`,
        transition: "box-shadow 0.3s ease, transform 0.3s ease",
        "&:hover": {
          boxShadow: `0px 3px 6px rgba(0, 0, 0, 0.25),
          0px 3px 4px rgba(0, 0, 0, 0.22),
          0px 4px 4px rgba(0, 0, 0, 0.2)`,
          transform: "translateY(-2px)",
        },
      }}
    >
      <Box
        component="img"
        src={src}
        alt={altText || `Thumbnail for ${videoId}`}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </Box>
  );
};

export default YouTubeThumbnail;
